<div class="main-container-warehouse">
    <div class="container-warehouse">
        <div class="container-warehouse--purple">
            <div class="warehouse-row" *ngFor="let x of [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]">
                <div class="container-warehouse__first-column">
                    <lib-box-child></lib-box-child>
                </div>
                <div class="container-warehouse__second-column">
                    <lib-box-child></lib-box-child>
                </div>
            </div>

        </div>

        <div class="container-warehouse--yellow">

        </div>

        <div class="container-warehouse--blue">

        </div>

        <div class="container-warehouse--green-dark">

        </div>

        <div class="container-warehouse--red">

        </div>

        <div class="container-warehouse--mustard">

        </div>
        <div class="container-warehouse--green">
            <div class="warehouse-row" *ngFor="let x of [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]">
                <div class="container-warehouse__first-column">
                    <lib-small-triangle></lib-small-triangle>
                </div>
                <div class="container-warehouse__second-column">
                    <lib-small-triangle></lib-small-triangle>
                </div>
            </div>
        </div>
        <div class="container-warehouse--green-light">
            <div class="container-warehouse-horizontal">
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
                <lib-small-triangle [height]="'16px'"></lib-small-triangle>
            </div>

        </div>
        <div class="container-warehouse--cyan">

            <div style="display: flex;">
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
            </div>
            <div style="display: flex; align-self: flex-end;">
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
                <lib-small-box></lib-small-box>
            </div>

        </div>

    </div>
</div>